export var SelfContainedFileName = /* @__PURE__ */ ((SelfContainedFileName2) => {
  SelfContainedFileName2["EXPORT_MANIFEST"] = "scene/export_manifest.json";
  SelfContainedFileName2["CODE_PREFIX"] = "scene/code";
  SelfContainedFileName2["PROPERTIES"] = "scene/code/properties.json";
  SelfContainedFileName2["EDITOR"] = "scene/editor.json";
  SelfContainedFileName2["ASSETS"] = "scene/assets.json";
  SelfContainedFileName2["POLYGONJS"] = "js/all.js";
  SelfContainedFileName2["SCENE_DATA_LOADER"] = "js/sceneDataLoader.js";
  SelfContainedFileName2["POLY_CONFIG"] = "js/polyConfig.js";
  SelfContainedFileName2["JS_FILES"] = "scene/js_files.json";
  SelfContainedFileName2["POSTER"] = "images/poster.png";
  return SelfContainedFileName2;
})(SelfContainedFileName || {});
